module.exports = {
	"data": [
		"http://share.soundtooth.cn/Pegato,SNBRN,Andrew Watt - Beat The Sunrise feat. Andrew Watt (Pegato Remix).mp3",
		"http://share.soundtooth.cn/Kygo - ID (Ultra Music Festival Anthem).mp3"
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/songlist.json
 ** module id = 582
 ** module chunks = 0
 **/